export default __webpack_public_path__ + "666e997e555b562d0c483f0406e67baf.png";